import { ReactElement, ReactNode } from 'react'
import { Tooltip, TooltipProps } from '@mui/material'

interface TooltipIconProps {
  title: ReactNode
  icon: ReactElement
  placement?: TooltipProps['placement']
  className?: string
}

const TooltipIcon = ({
  title,
  icon,
  placement = 'top',
  className,
}: TooltipIconProps): ReactElement => (
  <Tooltip
    title={title}
    placement={placement}
    className={className}
    arrow
    slotProps={{ popper: { sx: { padding: 1.5 } } }}
  >
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      {icon}
    </span>
  </Tooltip>
)

export default TooltipIcon
